export function chunkerizeArray<T>(array: Array<T> = [], chunkSize = 25) {
  const finalArray: Array<Array<T>> = []
  if (Array.isArray(array) && typeof chunkSize === 'number') {
    for (let i = 0; i < array.length; i += 1) {
      if (i % chunkSize === 0) {
        finalArray.push([])
      }
      const chunkIndex = parseInt(`${i / chunkSize}`, 10)
      finalArray[chunkIndex].push(array[i])
    }
  }
  return finalArray
}

export default chunkerizeArray
